export const localizationRu = {
  appbar: {
    downloadApk: 'Скачать приложение Android',
  },
  versionControl: {
    menu: 'Контроль версий',
    applyCurrentTitle: 'Применить текущий конфиг',
    rollbackTitle: 'Откат к версии',
    resetToBaseTitle: 'Сбросить к базовому конфигу',
    descriptionPlaceholder: 'Описание',
    version: 'Версия',
    versionsLoadError: 'Не удалось загрузить версии',
    applyCurrent: 'Применить текущий',
    restore: 'Восстановить',
    reset: 'Сбросить',
    resetConfirmText: 'Вы уверены, что хотите сбросить конфиг к базовой версии?',
  },
  sidebar: {
    links: {
      mobileReports: 'Отчёты приложения',
    },
  },
  pageTitle: {
    mobileReports: 'Отчёты приложения',
  },
  main: 'Главная',
  addIcon: 'Добавить иконку',
  removeIcon: 'Удалить иконку',
  vectorIconPicker: {
    title: 'Выбрать иконку',
    search: 'Поиск иконок...',
    size: 'Размер иконки',
    library: 'Библиотека',
    category: 'Категория',
    select: 'Выбрать',
    clear: 'Очистить',
    noIcons: 'Иконки не найдены',
    libraries: {
      all: 'Все библиотеки',
      fontAwesome5: 'FontAwesome 5',
      materialDesign: 'Material Design',
      materialIcons: 'Material Icons',
    },
    categories: {
      all: 'Все категории',
      AirsideOperations: 'Аэродромные операции',
      AircraftMaintenance: 'Техническое обслуживание',
      PassengerProcessing: 'Обработка пассажиров',
      GroundTransport: 'Наземный транспорт',
      TerminalServices: 'Сервисы терминала',
      SafetySecurity: 'Безопасность и охрана',
      NavigationWeather: 'Навигация и погода',
      LogisticsSupport: 'Логистика и поддержка',
      HospitalityRetail: 'Гостеприимство и торговля',
      Other: 'Другое',
    },
  },
}
